// @ts-nocheck
import loggingCore from '../core/logging-core'

export async function nativeDownloadFile(fileUrl: string, fileName: string) {
  try {
    // Fetch the PDF file as a blob
    const response = await fetch(fileUrl)
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    const blob = await response.blob()

    // Create a blob URL and trigger the download
    const blobUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    // Clean up the blob URL
    window.URL.revokeObjectURL(blobUrl)
  } catch (error) {
    loggingCore.error('File download failed', error)
  }
}
